import React from "react";
import styles from "./Input.module.css";

const Input = React.forwardRef((props, ref) => {
  const classStyle = props.className ? props.className : styles.input;

  return (
    <div className={classStyle}>
      {props.label && <label className={props?.rebrand ? styles.label:''}htmlFor={props.input?.id}>{props.label}</label>}
      <input className={props?.outline ? styles.border : ''} ref={ref} {...props.input} placeholder={props?.placeholder} style={props?.style}/>
    </div>
  );
});

export default Input;
